import React, { useState } from 'react'
import { useEffect } from 'react'
import { connectStore } from 'redux-box';
import { module as quiz2 } from 'store/quiz2'
import { module as ui } from 'store/ui'
import { module as activity } from 'store/activity'
import {
    AlignContentHorizontal, CardIcon
} from "static/styled/custom.styled";

import Select from 'react-select'
import './quiz_sync.css'
import { ThemeButton } from '../../../static/styled/custom.styled';

let platformsList = [
    {
        label: 'CMS',
        value: 'CMS'
    },
    {
        label: 'CBSE',
        value: 'CBSE'
    },
    {
        label: 'Hello',
        value: 'Hello'
    },
]
const customStyles = {
    menu: (provided, state) => ({
        ...provided,
        position: "absolute",
    }),
    control: (provide) => ({
        ...provide,
        width: "95%",
        margin: "0 auto",
        border: "none",
        boxShadow: "none",
    }),
};

const QuizSyncModal = ({ quiz2, ui, activity }) => {

    const [platforms, setPlatforms] = useState([])
    const [selectedQuizes, setSelectedQuizes] = useState(quiz2.sync_quiz_list.map((str) => str.id))

    const handleCardClicked = (quiz2) => {
        if (selectedQuizes.includes(quiz2.id)) {
            setSelectedQuizes(prev => prev.filter((data) => data !== quiz2.id))
        } else {
            setSelectedQuizes(prev => [...prev, quiz2.id])
        }
    }

    const handleSyncNow = () => {
        let payload = {
            platforms: platforms.map((plt) => plt.value),
            quiz_ids: selectedQuizes
        }
        quiz2.syncQuizToOtherPlatforms(payload)
        ui.hideModal()
    }

    const isChecked = (id) => selectedQuizes.some((item) => item === id);

    return (
        <div className='stories_sync_modal'>
            <p className='stories_sync_modal_header'>Sync quizes to other platforms</p>
            <div className="table-container">
                <table className="info-table">
                    <thead>
                        <tr className='stories_sync_table_header_row'>
                            <th>Action</th>
                            <th>Name</th>
                            <th>Grades</th>
                            <th>Description</th>
                            <th>Category</th>
                        </tr>
                    </thead>
                    <tbody>
                        {quiz2.sync_quiz_list && quiz2.sync_quiz_list.length > 0 ?
                            quiz2.sync_quiz_list.map((act, index) => {
                                // console.log(quiz2)
                                console.log('Checked?', act, isChecked(act.id), selectedQuizes);
                                return (
                                    <tr key={quiz2.id}>
                                        <td>
                                            <input type="checkbox" checked={isChecked(act.id)}
                                                onChange={() => handleCardClicked(act)} />
                                        </td>
                                        <td>{act.name}</td>
                                        <td>{activity.grades && activity.grades.length > 0 && activity.grades.filter((grd) => act.grade.includes(grd.id)).map((gr) => gr.name).join(", ")}</td>
                                        <td>{act.description}</td>
                                        <td>{act.quiz_category_name}</td>
                                    </tr>
                                )
                            })
                            :
                            <tr> No quiz added to sync.</tr>
                        }
                    </tbody>
                </table>
            </div>

            <div className="platforms_list_container">
                <p className="platforms_list_title">
                    Select Platforms
                </p>

                <Select
                    className="dropdown-container stories_sync_platform_select"
                    value={platforms}
                    onChange={(selectedSection) =>
                        setPlatforms(selectedSection)
                    }
                    options={platformsList}
                    placeholder="Select Platforms"
                    styles={customStyles}
                    menuPlacement="auto" // auto, top, or bottom
                    menuPosition="fixed"
                    isMulti={true}
                />
            </div>

            <ThemeButton primary onClick={handleSyncNow}>
                Sync Now
            </ThemeButton>
        </div>
    )
}

export default connectStore({
    quiz2, ui, activity
})(QuizSyncModal)